import { RootState } from 'src/store';

export const getGnrFilters = (state: RootState) => state.portfolio.gnrFilters.selectedFilters;
export const getGnrState = (state: RootState) => state.portfolio.gnrFilters;
